import Icon from "@ant-design/icons";
import type { CustomIconComponentProps } from "@ant-design/icons/lib/components/Icon";

const IconSvg = () => (
  <svg
    width="38"
    height="38"
    viewBox="0 0 38 38"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.26534 16.8435C4.68764 16.2658 4.39861 15.4599 4.47743 14.6468L5.15928 7.61265C5.28541 6.31144 6.31518 5.28167 7.61639 5.15554L14.6505 4.4737C15.4637 4.39487 16.2695 4.6839 16.8472 5.2616L22.8305 11.2449C23.898 12.3124 23.898 14.0433 22.8305 15.1108L15.1145 22.8268C14.047 23.8943 12.3162 23.8943 11.2486 22.8268L5.26534 16.8435Z"
      fill="#FEE8E8"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M21.864 12.2114L15.8807 6.22808C15.5919 5.93922 15.189 5.79471 14.7824 5.83412L7.74826 6.51597C7.09766 6.57903 6.58277 7.09392 6.51971 7.74452L5.83786 14.7786C5.79845 15.1852 5.94296 15.5881 6.23181 15.877L12.2151 21.8603C12.7489 22.394 13.6143 22.394 14.1481 21.8603L21.864 14.1443C22.3978 13.6105 22.3978 12.7451 21.864 12.2114ZM4.47743 14.6468C4.39861 15.4599 4.68764 16.2658 5.26534 16.8435L11.2486 22.8268C12.3162 23.8943 14.047 23.8943 15.1145 22.8268L22.8305 15.1108C23.898 14.0433 23.898 12.3124 22.8305 11.2449L16.8472 5.2616C16.2695 4.6839 15.4637 4.39487 14.6505 4.4737L7.61639 5.15554C6.31518 5.28167 5.28541 6.31144 5.15928 7.61265L4.47743 14.6468Z"
      fill="#D33D3D"
    />
    <path
      d="M13.6462 16.1579C13.1124 15.6241 13.1124 14.7587 13.6462 14.2249L14.231 13.6401C14.7648 13.1063 15.6302 13.1063 16.164 13.6401L22.288 19.7641C22.8217 20.2979 22.8217 21.1633 22.288 21.697L21.7031 22.2819C21.1693 22.8156 20.3039 22.8156 19.7702 22.2819L13.6462 16.1579Z"
      fill="#FEE8E8"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M15.1975 14.6066L14.6126 15.1914L20.7366 21.3154L21.3215 20.7306L15.1975 14.6066ZM13.6462 14.2249C13.1124 14.7587 13.1124 15.6241 13.6462 16.1579L19.7702 22.2819C20.3039 22.8156 21.1693 22.8156 21.7031 22.2819L22.288 21.697C22.8217 21.1633 22.8217 20.2979 22.288 19.7641L16.164 13.6401C15.6302 13.1063 14.7648 13.1063 14.231 13.6401L13.6462 14.2249Z"
      fill="#D33D3D"
    />
    <path
      d="M19.6852 24.2165C19.1515 23.6827 19.1515 22.8173 19.6852 22.2835L22.2843 19.6844C22.8181 19.1507 23.6835 19.1507 24.2173 19.6844L32.0631 27.5303C33.3146 28.7817 33.3146 30.8108 32.0631 32.0623C30.8116 33.3138 28.7825 33.3138 27.531 32.0623L19.6852 24.2165Z"
      fill="#FEE8E8"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M23.2508 20.6509L20.6517 23.25L28.4975 31.0958C29.2152 31.8135 30.3789 31.8135 31.0966 31.0958C31.8143 30.3781 31.8143 29.2144 31.0966 28.4967L23.2508 20.6509ZM19.6852 22.2835C19.1515 22.8173 19.1515 23.6827 19.6852 24.2165L27.531 32.0623C28.7825 33.3138 30.8116 33.3138 32.0631 32.0623C33.3146 30.8108 33.3146 28.7817 32.0631 27.5303L24.2173 19.6844C23.6835 19.1507 22.8181 19.1507 22.2843 19.6844L19.6852 22.2835Z"
      fill="#D33D3D"
    />
  </svg>
);

const EnhancementsIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={IconSvg} {...props} />
);

export default EnhancementsIcon;
